export default __webpack_public_path__ + "static/media/icon-auxiliares_diagnostico.700c288e.svg";